import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from '@/shared/shared.types';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C33IconCTALeftAlignedProps = RenderingProps<
  C33IconCTALeftAlignedFields,
  C33IconCTALeftAlignedRenderingParams
>;

export type C33IconCTALeftAlignedRenderingParams = {
  HeadlineTag?: string;
  HeadlineAlignment?: string;
  SupportCopyAlignment?: string;
  NumberOfColumns?: string;
  BackgroundColor?: string;
  ContentLayout?: string;
  LayoutStyle?: string;
  ContentWidth?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C33IconCTALeftAlignedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
  CTA?: LinkField;
};
